module.exports = __webpack_public_path__ + "static/media/9-3.bcbaa734.mp3";